import Vue from 'vue'
import Router from 'vue-router'
import Index from '../page/index'
import Detail from '../page/detail/detail'
// import Pay from '../page/pay/index'
import Honor from '../page/honor/index1'
import My from '../page/myself/index'
import Home from '../page/home'
import Login from '../page/myself/login'
import LoveRaise from '../page/Loveraise'
import spring from "../page/spring";
import Library from '../page/library'
Vue.use(Router)

const router = new Router({
    routes:[
        {
            path:'/',
            redirect:'/home'
        },
        {
            path:'/home',
            name:'Home',
            component:Home,
            meta:{
                title:'首页',
                tabbarShow:true
            }
        },
        {
            path:'/login',
            name:'Login',
            component:Login,
            meta:{
                title:'登录页面',
                tabbarShow:false
            }
        },
        {
            path:'/project',
            name:'Index',
            component:Index,
            meta:{
                title:'捐款项目',
                tabbarShow:false
            }
        },
        {
            path:'/library',
            name:'library',
            component:Library,
            meta:{
                title:'捐赠图书',
                tabbarShow:false
            }
        },
        {
            path:'/paylibrary',
            name:'paylibrary',
            component:() =>import('../page/pay/paylibrary'),
            meta:{
                title:'捐赠图书确认',
                tabbarShow:false
            }
        },
        {
            path:'/cert',
            name:'cert',
            component: () =>import('../page/pay/payCompleted'),
            meta:{
                title:'查看证书',
                tabbarShow:false
            }
        },
        {
            path:'/pay',
            name:'pay',
            component: () =>import('../page/pay/payMiddle'),
            meta:{
                title:'支付完成',
                tabbarShow:false
            }
        },
        {
            path:'/detail',
            name:'detail',
            component:Detail,
            meta:{
                title:'详情页面',
                tabbarShow:false
            }
        },
        {
            path:'/reset',
            name:'reset',
            component: () =>import('../page/resert'),
            meta:{
                title:'重置user',
                tabbarShow:false
            }
        },
        {
            path:'/loveraise',
            name:'loveraise',
            component:LoveRaise,
            meta:{
                title:'爱心排行榜',
                tabbarShow:false
            }
        },
        {
            path:'/spring',
            name:'spring',
            component:spring,
            meta:{
                title:'春季募捐',
                tabbarShow:false
            }
        },
        {
            path:'/agreement',
            name:'agreement',
            component:() =>import('../page/agree/index.vue'),
            meta:{
                tabbarShow:false
            }
        },

        {
            path:'/honor',
            name:'Honor',
            component:Honor
        },
        {
            path:'/my',
            name:'My',
            component:My,
            meta:{
                title:'我的',
                tabbarShow:true
            }
        }
    ]
})
router.beforeEach((to, from, next) => {
    if (to.path == '/login') {
        localStorage.setItem("preRoute", router.currentRoute.fullPath)
    }
    next()
})
export default router
